import { render, staticRenderFns } from "./AggridList.vue?vue&type=template&id=b5f95b68&"
import script from "./AggridList.vue?vue&type=script&lang=js&"
export * from "./AggridList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports